import React , { useState,useEffect }from 'react'
import { Button,  Form, Input,message, Space,Modal,Select,Radio,DatePicker,TimePicker,AutoComplete,InputNumber,Tag } from 'antd';
// import Icon,{EditOutlined  } from '@ant-design/icons';
// import './index.css';
import {api_order_add, api_order_edit, api_candidates_list} from '../../../api';
import EditTable from './editTable';
// import Tmp from './tmp.jsx'
import moment from 'moment';
// import 'moment/locale/zh-cn';
// // 设置 moment 语言为中文
// moment.locale('zh-cn');
import { encrypt,decrypt,localStorageSet,localStorageGet,waitTime } from '../../../utils/global.js';

// const { TextArea } = Input;
const { Option } = Select;
const screenHeight = document.body.clientHeight;
// let followOptions={follow:[], follow_email:[], follow_phone:[]};
const { RangePicker } = DatePicker;
// const CheckboxGroup = Checkbox.Group;

const App =(props)=>{
    const {showModal, closeModal, rowInfo, refreshlist, interviewMethodList, positionList, priorOptionList,interviewList,backUserList,meetingMethodList,tenantInfo} = props;
    console.log('1111111111111111111111111111111111111-', rowInfo, positionList, interviewMethodList, priorOptionList)
    const [form] = Form.useForm();
    const [editForm] = Form.useForm();
    const [editATimeForm] = Form.useForm();
    const [loading,setLoading] = useState(false);
    // const [clientList, setClientList] = useState([{id:'1',name:"",phone:"",email:""}]);
    const [clientList, setClientList] = useState([]);
    const [avlIntvTimeList, setAvlIntvTimeList] = useState([]);
    const [showNoonTime, setShowNoonTime] = useState(false);
    const [showInterviewLocation, setShowInterviewLocation] = useState(true);
    const [showMeetingMethod, setShowMeetingMethod] = useState(true);
    const [interviewerList, setInterviewerList] = useState([]);
    const [interviewerInfo, setInterviewerInfo] = useState({});
    const [interviewerInfoEmail, setInterviewerInfoEmail] = useState({});
    const [interviewerInfoDisable, setInterviewerInfoDisable] = useState(false);
    // const [dataSource, setDataSource] = useState([]);

    const currentUserinfo = localStorageGet('UserInfo_k');

    useEffect(() => {
      if(showModal){
        getInterviewerlist();
        if(rowInfo.id == undefined){
          form.resetFields();
          // form.setFieldValue("client_list", []);
        } else {
          getCandidateList();
          for (let key in rowInfo) {
            if(key=='avl_intv_time'){
              if(rowInfo.avl_intv_time){
                var avl_intv_time = JSON.parse(rowInfo.avl_intv_time);
                var list = [];
                for(let i in avl_intv_time){
                  list.push({id:i,atime:avl_intv_time[i]});
                }
                console.log('=======list=========', list)
                setAvlIntvTimeList(list);
                form.setFieldValue("avl_intv_time", list);
              }
            }else if(key=='noon_time'){
              if(rowInfo[key]){
                var time = rowInfo[key].split("-");
                // console.log('--------noon_time---------', time);
                form.setFieldValue(key, [moment(time[0],"HH:mm"), moment(time[1],"HH:mm")] )
              }
              // noon_time:[moment("11:30","HH:mm"), moment("13:30","HH:mm")]
            } else if(key=='execute_time'){
              form.setFieldValue(key, moment(rowInfo.execute_time,"YYYY-MM-DD HH:mm"))
            }else{
              // console.log(' --------setFieldValue---------- ')
              // console.log(key, rowInfo[key])
              form.setFieldValue(key, rowInfo[key])
            }
            setInterviewerInfoDisable(true);
            if(rowInfo.avoid_noon=='1')
              setShowNoonTime(true);
            else
              setShowNoonTime(false);
            if(rowInfo.interview_method==1)
              setShowInterviewLocation(false);
            else
              setShowInterviewLocation(true);
            if(rowInfo.interview_method==2)
              setShowMeetingMethod(false);
            else
              setShowMeetingMethod(true);
          }
        }
      }else{
        form.resetFields();
        setLoading(false);
        setClientList([]);
        setAvlIntvTimeList([]);
        setShowNoonTime(false);
        setShowInterviewLocation(true);
        setShowMeetingMethod(true);
        setInterviewerList([]);
        setInterviewerInfo({});
        setInterviewerInfoEmail({});
        setInterviewerInfoDisable(false);
      }
    }, [showModal]);


  // 获取候选人列表
  const getCandidateList = async ()=>{
    try {
      api_candidates_list({from:"order",work_order_id:rowInfo.work_order_id}).then((res) => {
        console.log('api_candidates_list-res-----------------', res);
        // var flag = checkLogin('A', res.data)
        if (res.data.code == 9) {
          var list = [];
          for(let item of res.data.list){
            // status.push({value:item.interviewer_id, label:item.name});
            list.push({id:item.candidate_id, name:item.name, phone:item.phone, email:item.email});
          }
          console.log('------------setClientList-----------', list)
          setClientList(list);
          form.setFieldValue("client_list", list)
        }else
          message.error(res.data.msg);
      });
    } catch (error) {
      console.log('catch-error------------', error)
      // return false;
    }

  }
  
  // 获取面试官列表
  const getInterviewerlist = async ()=>{
    var list = [];
    var info = {};
    var infoemail = {};
    console.log('interviewList ----------- ', interviewList)
    for(let item of interviewList){
      list.push({value:item.name, id:item.interviewer_id});
      info[item.name] = item;
      infoemail[item.email] = item;
    }
    console.log('list ------- ',list)
    console.log('info ------- ',info)
    setInterviewerList(list);
    setInterviewerInfo(info);
    setInterviewerInfoEmail(infoemail);
  }

  const onChangeInterviewerName = (data) => {
    console.log('interviewer_name ----------',data)
    console.log('interviewer_info ----------',interviewerInfo[data])
    if(interviewerInfo[data]){
      form.setFieldValue("interviewer_phone", interviewerInfo[data].phone);
      form.setFieldValue("interviewer_email", interviewerInfo[data].email);
      setInterviewerInfoDisable(true);
    }
    else{
      // form.setFieldValue("interviewer_phone", "");
      // form.setFieldValue("interviewer_email", "");
      setInterviewerInfoDisable(false);
    }
  };

  const onChangeAvoidnoon = (e) => {
    var data = e.target.value
    console.log(data)
    if(data=='1')
      setShowNoonTime(true);
    else
      setShowNoonTime(false);
  };

  const onChangeIntvMethod = (e) => {
    var data = e.target.value
    console.log(data)
    if(data==1)
      setShowInterviewLocation(false);
    else
      setShowInterviewLocation(true);
    if(data==2)
      setShowMeetingMethod(false);
    else
      setShowMeetingMethod(true);
  };

  const now = moment();
  // const tomorrow = now.clone().add(1, 'day').startOf('day');
  const disabledTime = (current) => {
    if (!current || current.isSame(now, 'day')) {
      return {
        disabledHours: () => {
          const hours = [];
          for (let i = 0; i < now.hours(); i++) {
            hours.push(i);
          }
          return hours;
        },
        disabledMinutes: (selectedHour) => {
          if (selectedHour==-1 || selectedHour === now.hours()) {
            const minutes = [];
            for (let i = 0; i < now.minutes(); i++) {
              minutes.push(i);
            }
            return minutes;
          }
          return [];
        },
        disabledSeconds: () => [],
      };
    }
    return {
      disabledHours: () => [],
      disabledMinutes: () => [],
      disabledSeconds: () => [],
    };
  }; 

  const disabledDate = (current) => {
      return current && current < moment().startOf('day');
  };

  const tagRender = (props) => {
    const { label, value, closable, onClose } = props;
    console.log('------tagRender---------', value, typeof(value))
    if (value==currentUserinfo.id) {
      // 如果是不可删除的选项，不渲染关闭图标
      return <span>{label}</span>;
    }else{
    return (
      <Tag
        closable={closable}
        onClose={(e) => {
          e.preventDefault();
          onClose();
        }}
      >
        {label}
      </Tag>)
    ;}
  };

    // const onSelectInterviewerName = (data) => {
    //   console.log('interviewer_name ----------',data)
    //   console.log('interviewer_info ----------',interviewerInfo[data])
    //   if(interviewerInfo[data]){
    //     form.setFieldValue("interviewer_phone", interviewerInfo[data].phone);
    //     form.setFieldValue("interviewer_email", interviewerInfo[data].email);
    //     setInterviewerInfoDisable(true);
    //   }
    //   else{
    //     // form.setFieldValue("interviewer_phone", "");
    //     // form.setFieldValue("interviewer_email", "");
    //     setInterviewerInfoDisable(false);
    //   }
    // };

    // const onBlurEmail = (e) => {
    //   if(form.getFieldValue("interviewer_name"))
    //     return;

    //   var data = e.target.value
    //   console.log('email ----------',data)
    //   var i = data.search("@");
    //   console.log('i ----------',i)
    //   var name = data;
    //   if(i>0)
    //     name = data.substring(0, i);
    //   console.log('name ----------',name)
    //   form.setFieldValue("interviewer_name", name);
    // };

    const onFinish = async(value)=>{
      console.log(value);
      if(interviewerInfoEmail[value.interviewer_email]){
        if(interviewerInfoEmail[value.interviewer_email].name != value.interviewer_name){
          message.warning("面试官邮箱已存在，姓名为“"+interviewerInfoEmail[value.interviewer_email].name+"”");
          return false;
        }
      }
      // await editATimeForm.validateFields();
      // 可用面试时间
      var avl_intv_time = [];
      if(value.avl_intv_time){
        var pre = ["",""];
        for(let t of value.avl_intv_time){
          if(t.atime){
            avl_intv_time.push(t.atime);
            if(t.atime[0]<=pre[1]){
              message.warning("时间段须按由近到远递增原则设置");
              return false;
            }
            pre = t.atime;
          }
        }
      }
      value.avl_intv_time = avl_intv_time;

      if(value.avoid_noon=='1' && !value.noon_time){
        message.warning("请输入午休时间");
        return false;
      }
      // 午休时间
      if(value.noon_time){
        const [start2, end2] = value.noon_time;
        const noon_stime = start2 ? moment(start2).format('HH:mm') : null;
        const noon_etime = end2 ? moment(end2).format('HH:mm') : null;
        console.log('午休开始时间:', noon_stime);
        console.log('午休结束时间:', noon_etime);
        value.noon_time = [noon_stime, noon_etime];
      }
      if((value.interview_method == "2" || value.interview_method == "3") && !value.interview_location){
        message.warning("请输入面试地点");
        return false;
      }

      if(!value.client_list || value.client_list.length==0){
        message.warning("请输入候选人");
        return false;
      }
      await editForm.validateFields();
      // 判断候选人手机号、邮箱是否重复
      let phones = [];
      let emails = [];
      for(let v of value.client_list){
        if(phones.includes(v.phone)){
          message.warning("候选人的手机号不能重复，请检查"+v.name+"的手机号");
          return false;
        }
        else
          phones.push(v.phone);

        if(emails.includes(v.email)){
          message.warning("候选人的邮箱不能重复，请检查"+v.name+"的邮箱");
          return false;
        }
        else
          emails.push(v.email);
      }
      // 工单执行时间
      value.execute_time = moment(value.execute_time).format('YYYY-MM-DD HH:mm');
      let cur_time = moment().format('YYYY-MM-DD HH:mm');
      console.log('value.execute_time -------- ',value.execute_time)
      console.log('cur_time -------- ',cur_time)
      if(value.execute_time < cur_time){
        value.execute_time = cur_time;
        form.setFieldValue("execute_time", moment(cur_time,"YYYY-MM-DD HH:mm"))
      }

      // if( - tenantInfo.time_interval)
      if(value.avl_intv_time && value.avl_intv_time.length>0){
        const timestamp = moment(value.avl_intv_time[0][0], "YYYY-MM-DD HH:mm").valueOf(); // 使用valueOf()获取时间戳
        const timestamp2 = moment(value.execute_time, "YYYY-MM-DD HH:mm").valueOf(); // 使用valueOf()获取时间戳
        console.log(value.avl_intv_time[0][0]); 
        console.log(value.execute_time); 
        console.log(timestamp); 
        console.log(timestamp2); 
        console.log(tenantInfo.time_interval); 
        console.log(tenantInfo.time_interval*3600*1000); 
        if(timestamp-timestamp2 < tenantInfo.time_interval*3600*1000){
          message.warning("工单启动时间必须提前可用面试时间"+tenantInfo.time_interval+"小时");
          return false;
        }
      }

      console.log('提交数据 ----- ',value);
      if(!value.interviewer_name){
        var name = value.interviewer_email.substring(0, value.interviewer_email.search("@"));
        Modal.confirm({
          title: '确认面试官姓名',
          content: '面试官姓名为空，以"'+name+'"为面试官姓名吗？',
          onCancel() {
            return false;
          },
          onOk() {
            form.setFieldValue("interviewer_name", name);
            value.interviewer_name = name;
            submitDataToInter(value);
          },
        });
      }
      else
        submitDataToInter(value);
    }

    const submitDataToInter = async(value)=>{

      value.id = rowInfo.id;

      setLoading(true);
      try {
        var fun = rowInfo.id ? api_order_edit : api_order_add;
        fun(value).then((res) => {
          setLoading(false);
          console.log(fun+'-res-----------------', res);
          if (res.data.code == 9) {
            if(res.data.msg)
              Modal.warning({
                title: '提示',
                content: "工单已"+(rowInfo.id?"修改":"创建")+"，但是"+res.data.msg,
              });
              // message.error("工单已"+(rowInfo.id?"修改":"创建")+"，但是"+res.data.msg, 0);
            else
              message.success("操作成功");
            closeModal();
            refreshlist();
          }else{
            message.error(res.data.msg);
            if(res.data.code==100)
              form.setFieldValue("ai_auto_time", "0");
          }
        });
        } catch (error) {
          message.error("异常错误");
          setLoading(false);
          return false;
        }
      }


     //发布(字段没填写完整)
     const onFinishFailed = async (e) => {
      // console.log(e.errorFields[0].name)
          // form.scrollToField(e.errorFields[0].name) // 滚动到对应字段位置
        setTimeout(()=>{
            document.querySelector('.ant-form-item-has-error')?.scrollIntoView({behavior: 'smooth', block: 'center'});
        }, 100)
    }


  return (
    <Modal 
        key="orderinfo"
        title={(rowInfo.tenant_id ? '编辑' :'新建')+"工单"}
        open={showModal}
        width={"70%"}
        bodyStyle={{maxHeight:screenHeight*0.8,overflowY:"scroll"}}
        centered
        destroyOnClose={true}
        maskClosable={false}
        footer={[<Button  className="m-btn-white" onClick={closeModal}>
        取消
        </Button>,
        <Button type="primary" loading={loading} style={{ marginLeft:'20px',backgroundColor:"rgb(24,188,156)"}} onClick={()=>{form.submit()}}>
        确认
        </Button>] }
        onCancel={closeModal}>
          <Form form={form}
            className='loginForm reginfo'
            name="normal_login"
            // labelCol={{span: 5}}
            // wrapperCol={{span: 16}}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            layout="horizontal"
            // autoComplete="off"
            labelAlign="left"
            labelCol={{span:5}}
            // style={{fontSize:12}}
            size="small"
            initialValues={{
              interview_method:3, 
              avoid_noon:'0', 
              prior_option:2, 
              duration:60,
              ai_auto_time:"0",
              noon_time:[moment("11:30","HH:mm"), moment("13:30","HH:mm")],
              meeting_method:1,
              // client_list:clientList,
              // avl_intv_time:avlIntvTimeList,
              interview_location:tenantInfo.address
            }}
        >
          
          <Form.Item
                label="安排方式"
                name="prior_option"
            >
              <Radio.Group style={{width:"80%"}}  >
                <Space size={10}>
                  {
                    priorOptionList.map(item=><Radio value={item.value}>{item.label}</Radio>)
                  }

                {/* <Radio value={"time"}>时间优先</Radio>
                <Radio value={"cand"}>候选人优先</Radio> */}
                </Space>
              </Radio.Group>
            </Form.Item>
            <Form.Item
                label="工作岗位"
                name="position_name"
                rules={[
                  {required: true, message: '请输入或选择工作岗位',},
                ]}
            >
              <AutoComplete
                options={positionList}
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              />
            </Form.Item>
            <Form.Item
                label="面试官姓名"
                name="interviewer_name"
                // rules={[
                //   {required: true, message: '请输入或选择面试官姓名',},
                // ]}
            >
              <AutoComplete
                options={interviewerList}
                allowClear
                // optionFilterProp="children"
                filterOption={(input, option) =>
                  option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                onChange={onChangeInterviewerName}
                // onBlur={onBlurInterviewerName}
                // onSelect={onSelectInterviewerName}
                // onSearch={onSearch}
                // placeholder="跟进人"
              />
            </Form.Item>
            <Form.Item
                label="面试官手机"
                name="interviewer_phone"
                rules={[
                  // {required: true, message: '请输入面试官手机',},
                  {
                    pattern: /^1[3-9]\d{9}$/,
                    message: '请输入有效的手机号码',
                  },
                ]}
            >
            <Input disabled={interviewerInfoDisable} />
            </Form.Item>
            <Form.Item
                label="面试官邮箱"
                name="interviewer_email"
                rules={[
                  {required: true, message: '请输入面试官邮箱',},
                  {
                    type: 'email',
                    message: '请输入有效的邮箱地址',
                  },
                ]}
            >
            <Input disabled={interviewerInfoDisable} 
              // onBlur={onBlurEmail} 
            />
            </Form.Item>
            <EditTable
              editForm={editATimeForm}
              label = {"可用面试时间"}
              name = {"avl_intv_time"}
              initdata = {avlIntvTimeList}
              worktime = {tenantInfo.work_time}
              started = {rowInfo.started}
            />
            {/* <Form.Item
                label="可用面试时间"
                name="avl_intv_time0"
                // rules={[
                //   {required: true, message: '请输入可用面试时间',},
                // ]}
            >
              <RangePicker
                showTime={{ format: 'HH:mm' }}
                format="YYYY-MM-DD HH:mm"
                // defaultValue={defaultTimeRange}
                placeholder={['开始时间', '结束时间']}
              />
            </Form.Item>
            <Form.Item
                label=" "
                colon={false}
                name="avl_intv_time1"
                // rules={[
                //   {required: true, message: '请输入可用面试时间',},
                // ]}
            >
              <RangePicker
                showTime={{ format: 'HH:mm' }}
                format="YYYY-MM-DD HH:mm"
                // defaultValue={defaultTimeRange}
                placeholder={['开始时间', '结束时间']}
              />
            </Form.Item>
            <Form.Item
                label=" "
                colon={false}
                name="avl_intv_time2"
                // rules={[
                //   {required: true, message: '请输入可用面试时间',},
                // ]}
            >
              <RangePicker
                showTime={{ format: 'HH:mm' }}
                format="YYYY-MM-DD HH:mm"
                // defaultValue={defaultTimeRange}
                placeholder={['开始时间', '结束时间']}
              />
            </Form.Item> */}
            <Form.Item
                label={<div><p style={{lineHeight:0.2}}>面试官是否授权</p><p style={{lineHeight:0}}>根据日历安排</p></div>}
                name="ai_auto_time"
                style={{display:tenantInfo.is_outlook_enabled=='1'?"":"none"}}
            >
              <Radio.Group style={{width:"80%"}} >
                <Space size={10}>
                <Radio value={"1"}>是</Radio>
                <Radio value={"0"}>否</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
            <Form.Item
                label="避开午休"
                name="avoid_noon"
            >
              <Radio.Group style={{width:"80%"}} onChange={onChangeAvoidnoon} >
                <Space size={10}>
                <Radio value={"1"}>是</Radio>
                <Radio value={"0"}>否</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
            <Form.Item
                label="午休时间"
                name="noon_time"
                style={{display:showNoonTime?"":"none"}}
                // rules={[
                //   {required: true, message: '请输入租户名称',},
                // ]}
            >
              <TimePicker.RangePicker
                showTime={{ format: 'HH:mm' }}
                format="HH:mm"
                // defaultValue={defaultTimeRange}
                placeholder={['开始时间', '结束时间']}
              />
            </Form.Item>
            <Form.Item
                label="面试方式"
                name="interview_method"
            >
              <Radio.Group style={{width:"80%"}} onChange={onChangeIntvMethod}>
                <Space size={10}>
                  {
                    interviewMethodList.map(item=><Radio value={item.value}>{item.label}</Radio>)
                  }
                {/* <Radio value={"0"}>电话面试</Radio>
                <Radio value={"1"}>视频面试</Radio>
                <Radio value={"2"}>线下面试</Radio> */}
                </Space>
              </Radio.Group>
            </Form.Item>
            <Form.Item
                label="面试地点"
                name="interview_location"
                style={{display:showInterviewLocation?"":"none"}}
            >
            <Input />
            </Form.Item>
            <Form.Item
                label="会议软件"
                name="meeting_method"
                style={{display:showMeetingMethod?"":"none"}}
            >
              <Radio.Group style={{width:"80%"}}>
                <Space size={10}>
                  {
                    meetingMethodList.map(item=><Radio value={item.value}>{item.label}</Radio>)
                  }
                {/* <Radio value={"0"}>电话面试</Radio>
                <Radio value={"1"}>视频面试</Radio>
                <Radio value={"2"}>线下面试</Radio> */}
                </Space>
              </Radio.Group>
            </Form.Item>
            <Form.Item
                label="会议地址"
                name="meeting_url"
                style={{display:showMeetingMethod?"":"none"}}
            >
            <Input />
            </Form.Item>
            <Form.Item
              label="面试时长(分钟)"
                name="duration"
                rules={[
                  {required: true, message: '请输入面试时长',},
                ]}
            >
              <InputNumber min={1} />
            </Form.Item>
            <Form.Item
                label="后备联络人"
                name="back_userid"
                // rules={[
                //   {required: true, message: '请选择工作岗位',},
                // ]}
            >
              <Select
                mode="multiple"
                // options={backUserList}
                // allowClear
                tagRender={tagRender}
              >
                {backUserList.map((option) => (
                <Option key={"backuser_"+option.value} value={option.value} disabled={option.value==currentUserinfo.id||option.value==rowInfo.creat_userid?true:false}>
                    {option.label}
                </Option>
            ))}
              </Select>
            </Form.Item>
            <EditTable
              editForm={editForm}
              label = {"候选人"}
              name = {"client_list"}
              initdata = {clientList}
              worktime = {tenantInfo.work_time}
              started = {rowInfo.started}
            />
            {/* <Form.Item
                label="候选人列表"
                name="client_list"
            >
              <Tmp
                dataSource={dataSource}
                setDataSource={setDataSource}
              />

            </Form.Item> */}
            <Form.Item
                label="工单启动时间"
                name="execute_time"
                rules={[
                  {required: true, message: '请输入工单启动时间',},
                ]}
            >
              <DatePicker 
                showTime={{ format: 'HH:mm' }} 
                format="YYYY-MM-DD HH:mm" 
                placeholder='请选择时间' 
                disabledDate={disabledDate}
                disabledTime={disabledTime}
              />
            </Form.Item>

        </Form>
        </Modal>
  )
}
export default App
